import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/analytics')({
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">Analytics</h1>
      <p className="text-muted-foreground text-sm">
        Platform-wide insights and reporting.
      </p>
    </div>
  );
}
